import '../translations'
import '../styles/tailwind.css'
import * as React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { KeyRound, ReceiptText, UserX } from 'lucide-react'
import { Toaster } from '@/components/ui/sonner'
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@/components/ui/sidebar'
import { NavMain } from '../components/nav-main'
import SignInLinkPage from './pages/SignInLinkPage'
import PeppolPage from './pages/PeppolPage'
import DeleteUserPage from './pages/DeleteUserPage'

export default function Application() {
  const { t } = useTranslation()

  const items = [
    { title: t('admin::Sign-in link'), url: '/sign-in-link', icon: <KeyRound /> },
    { title: t('admin::Peppol'), url: '/peppol', icon: <ReceiptText /> },
    { title: t('admin::Delete user'), url: '/delete-user', icon: <UserX /> },
  ]

  return (
    <BrowserRouter basename="/admin/application">
      <SidebarProvider>
        <Sidebar>
          <SidebarHeader className="px-4 py-3 font-semibold">{t('admin::Bizzey admin')}</SidebarHeader>
          <SidebarContent>
            <NavMain items={items} />
          </SidebarContent>
        </Sidebar>
        <SidebarInset>
          <header className="flex h-12 items-center border-b px-4">
            <SidebarTrigger />
          </header>
          <main className="mx-auto w-full max-w-3xl p-6">
            <Switch>
              <Route path="/sign-in-link" component={SignInLinkPage} />
              <Route path="/peppol" component={PeppolPage} />
              <Route path="/delete-user" component={DeleteUserPage} />
              <Redirect to="/sign-in-link" />
            </Switch>
          </main>
        </SidebarInset>
        <Toaster />
      </SidebarProvider>
    </BrowserRouter>
  )
}
